export const ADMIN_NAV_ITEMS = ['Мой профиль', 'Диалоги', 'Команда', 'Посетители', 'Статистика', 'Биллинг', 'Управление', 'Настройки']

export const ADMIN_NAV_ROUTES: Record<string, string> = {
  'Мой профиль': '/myProfile',
  'Диалоги': '/dialogs',
  'Команда': '/team',
  'Посетители': '/visitors',
  'Статистика': '/statistics',
  'Биллинг': '/billing',
  'Управление': '/control',
  'Настройки': '/settings',
}

export const ADMIN_NAV_I18N_KEYS: Record<string, string> = {
  'Мой профиль': 'nav.my_profile',
  'Диалоги': 'nav.dialogs',
  'Команда': 'nav.team',
  'Посетители': 'nav.visitors',
  'Статистика': 'nav.statistics',
  'Биллинг': 'nav.billing',
  'Управление': 'nav.management',
  'Настройки': 'nav.settings',
}

/** JWT / API role value (case-insensitive). */
export function isOperatorUserRole(role?: string | null): boolean {
  return String(role ?? '').trim().toLowerCase() === 'operator'
}

const OPERATOR_HIDDEN_NAV = new Set<string>(['Команда', 'Биллинг', 'Управление'])

export function getAdminNavItemsForRole(
  role?: string | null,
  options?: { canManageBilling?: boolean; emailUnverified?: boolean },
): string[] {
  if (options?.emailUnverified) return ['Мой профиль']
  const items = isOperatorUserRole(role)
    ? ADMIN_NAV_ITEMS.filter((item) => !OPERATOR_HIDDEN_NAV.has(item))
    : [...ADMIN_NAV_ITEMS]
  if (options?.canManageBilling === false) {
    return items.filter((item) => item !== 'Биллинг')
  }
  return items
}

export function getAdminNavRoutesForRole(
  role?: string | null,
  options?: { canManageBilling?: boolean; emailUnverified?: boolean },
): Record<string, string> {
  const items = getAdminNavItemsForRole(role, options)
  const routes: Record<string, string> = {}
  for (const item of items) {
    routes[item] = ADMIN_NAV_ROUTES[item]
  }
  return routes
}

export function postAuthLandingPath(role?: string | null): string {
  return isOperatorUserRole(role) ? '/dialogs' : '/control'
}








